export default __webpack_public_path__ + "static/media/rocket.b39bd3a5.svg";